import { $, on } from '../lib/domUtils'

function event({ action, category, label }) {
  if (window.ga) {
    window.ga('send', 'event', {
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
    })
  }
}

window.addEventListener('klaviyoForms', e => {
  // pre order form ID: UtfFfa
  if (e.detail.type === 'submit' && e.detail.formId === 'UtfFfa') {
    event({
      action: 'submit',
      category: 'pre-order',
      label: 'form-pre-order',
    })
  }
})
